module.exports = __webpack_public_path__ + "img/badge-star.765ed249.svg";